export default __webpack_public_path__ + "static/media/faq.f2c26018.svg";